<template>
    <ul class="content-share">
        <li><a :href="`mailto:?subject=${title}&body=${url}`" alt="" title="">
            <img src="@/assets/images/share-mail.png" alt="Mail"></a>
        </li>
        <li>
            <a :href="`http://www.facebook.com/sharer.php?u=${url}`" target="_blank" alt="" title="">
                <img src="@/assets/images/share-facebook.png" alt="Facebook">
            </a>
        </li>
        <li>
            <a :href="`whatsapp://send?text=${url} ${title}`" alt="" title="">
                <img src="@/assets/images/share-whatsapp.png" alt="WhatsApp">
            </a>
        </li>
        <li>
            <a :href="`https://twitter.com/share?url=${url}&text=${title}&hashtags=gazetaweb`" target="_blank" alt="" title="">
                <img src="@/assets/images/share-twitter.png" alt="Twitter">
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Share',
    props:['title'],
    data() {
        return {
            url: null
        }
    },
    mounted() {
        this.url = `${window.location.href}`
    }
}
</script>